enum ApiErrorCode {
  ACIONAMENTO_NAO_ENCONTRADO = 'ACIONAMENTO_NAO_ENCONTRADO',

  CADASTRO_CPF_CNPJ_INVALIDO = 'Cadastro_CpfCnpjInvalido',
  CADASTRO_DADOS_NAO_ENCONTRADOS = 'Cadastro_DadosNaoEncontrados',
  CADASTRO_DATA_DE_NASCIMENTO_INVALIDA = 'Cadastro_DataDeNascimentoInvalida',
  CADASTRO_EMAIL_JA_CADASTRADO = 'Cadastro_EmailJaCadastrado',
  CADASTRO_GOOGLE_PRE_CADASTRO_NAO_REALIZADO = 'CadastroGoogle_PreCadastroNaoRealizado',
  CADASTRO_LOGIN_JA_CADASTRADO = 'Cadastro_LoginJaCadastrado',
  CADASTRO_TOKEN_CONFIRMACAO_EMAIL_INVALIDO = 'Cadastro_TokenConfirmacaoEmailInvalido',
  CADASTRO_TELEFONE_INVALIDO = 'Cadastro_TelefoneFormatoInvalido',

  DEEP_LINK_CAPTACAO_DADOS_NAO_ENCONTRADOS = 'DeepLinkCaptacao_DadosNaoEncontrados',
  DEEP_LINK_CAPTACAO_LIMITE_TENTATIVAS_ATINGIDO = 'DeepLinkCaptacao_LimiteTentativasAtingido',
  DEEP_LINK_CAPTACAO_TOKEN_EXPIRADO = 'DeepLinkCaptacao_TokenExpirado',
  DEEP_LINK_CAPTACAO_TOKEN_FORMATO_INVALIDO = 'DeepLinkCaptacao_TokenFormatoInvalido',
  DEEP_LINK_CAPTACAO_TOKEN_INVALIDO = 'DeepLinkCaptacao_TokenInvalido',

  DEEP_LINK_CAPTACAO_EMAIL_CPF_INVALIDO = 'DeepLinkCaptacaoEmail_DigitosCpfCnpjInvalido',
  DEEP_LINK_CAPTACAO_EMAIL_FORMATO_CPF_INVALIDO = 'DeepLinkCaptacaoEmail_FormatoCpfInvalido',
  DEEP_LINK_CAPTACAO_EMAIL_LIMITE_TENTATIVAS_ATINGIDO = 'DeepLinkCaptacaoEmail_LimiteTentativasAtingido',
  DEEP_LINK_CAPTACAO_EMAIL_PRE_CADASTRO_NAO_ENCONTRADO = 'DeepLinkCaptacaoEmail_PreCadastroNaoEncontrado',
  DEEP_LINK_CAPTACAO_EMAIL_USUARIO_JA_CADASTRADO = 'DeepLinkCaptacaoEmail_UsuarioJaCadastrado',

  DEEPLINK_CAPTACAO_EMAIL_JA_CADASTRADO = 'DeeplinkCaptacao_EmailJaCadastrado',
  DEEP_LINK_EMAIL_JA_CADASTRADO = 'DeepLink_EmailJaCadastrado',

  PRE_CADASTRO_EMAIL_JA_CADASTRADO = 'PreCadastro_EmailJaCadastrado',

  DIVIDA_DIVIDA_NAO_NEGOCIAVEL = 'Divida_DividaNaoNegociavel',
  DIVIDA_DIVIDA_NAO_ENCONTRADA = 'Divida_DividaNaoEncontrada',
  DIVIDA_INEXISTENTE = 'Divida_Inexistente',
  DIVIDA_STATUS = 'Divida_Status',

  GOOGLE_AUTHENTICATION = 'GoogleAuthetication', // typo na string conforme backend

  LOGIN_BANIMENTO = 'Login_Banimento',
  LOGIN_DATA_DE_NASCIMENTO_INVALIDA = 'Login_DataDeNascimentoInvalida',
  LOGIN_EMAIL_INVALIDO = 'Login_EmailInvalido',
  LOGIN_EMAIL_NAO_VALIDADO = 'Login_EmailNaoValidado',
  LOGIN_USUARIO_NAO_CADASTRADO = 'Login_UsuarioNaoCadastrado',

  NAO_RECEBE_PROPOSTA = 'Nao_Recebe_Proposta',
  NEGOCIACAO_INATIVA = 'Negociacao_Inativa',
  NENHUM_CONSUMIDOR_ENCONTRADO = 'NENHUM_CONSUMIDOR_ENCONTRADO',

  PROPOSTA_ATIVA_EXISTENTE = 'Proposta_AtivaExistente',
  PROPOSTA_PERCENTUAL_MINIMO_ENTRADA = 'Proposta_PercentualMinimoEntrada',
  PROPOSTA_QUANTIDADE_DE_PARCELAS = 'Proposta_QuantidadeDeParcelas',
  PROPOSTA_QUANTIDADE_DE_PROPOSTAS_EXCEDIDA = 'Proposta_QuantidadeDePropostasExcedida',
  PROPOSTA_SEM_ENTRADA = 'Proposta_SemEntrada',
  PROPOSTA_STATUS = 'Proposta_Status',
  PROPOSTA_VALOR_ENTRADA = 'Proposta_ValorEntrada',
  PROPOSTA_VALOR_MAIOR_QUE_VALOR_DIVIDA = 'Proposta_ValorMaiorQueValorDivida',
  PROPOSTA_VALOR_MINIMO_ENTRADA = 'Proposta_ValorMinimoEntrada',
  PROPOSTA_VALOR_PARCELA = 'Proposta_ValorParcela',
  PROPOSTA_NAO_ENCONTRADA = 'Proposta_NaoEncontrada',

  RECAPTCHA = 'Recaptcha',
  SESSAO_EXPIRADA = 'SESSAO_EXPIRADA',

  TOKEN_INVALIDO = 'Token_Invalido',
  TOKEN_JA_UTILIZADO = 'Token_Ja_Utilizado',
  TOKEN_EXPIRADO = 'Token_Expirado',
  TOKEN_EXPIRADO_DEFINITIVAMENTE = 'Token_Expirado_Definitivamente',

  USUARIO_JA_CADASTRADO = 'Usuario_Ja_Cadastrado',

  CREDOR_INDISPONIVEL = 'Credor_Indisponivel',

  CODIGO_OTP_INCORRETO = 'CodigoOtpIncorreto',
  CODIGO_OTP_EXPIRADO = 'CodigoOtpExpirado',

  TELEFONE_FORMATO_INVALIDO = 'TelefoneFormatoInvalido',
}

export default ApiErrorCode;
